export { default as PhoneNumber } from './phone-number';
export { default as Amount } from './amount';
export { default as Email } from './email';
export { default as Password } from './password';
export { default as InputNumber } from './input-number';
export { default as TextArea } from './text-area';
export { default as InputDate } from './input-date';
export { default as CreditCard } from './credit-card';
export { default as Otp } from './otp';
export { default as ExpiryDate } from './expiry-date';
export { default as InputId } from './input-id';
import IglooInput from './input';
export default IglooInput;